import { Component, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CallHistoryBrowserBehaviourState } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.state';
import _ from 'lodash';

@Component({
   selector: 'samweb-call-agent',
   templateUrl: './call-agent.component.html',
   styleUrls: ['./call-agent.component.scss'],
})
export class CallAgentComponent implements OnInit {
   constructor(private store: Store) {}

   @Input()
   public callHistoryForCallId: number;

   @Input()
   public origAgentValue: string;

   @Input()
   public searchValue: string;

   public shownAgentValue$: Observable<any>;

   ngOnInit(): void {
      this.shownAgentValue$ = this.store
         .select(CallHistoryBrowserBehaviourState.getProgressByUserForHistoryEntryFn)
         .pipe(map((fn) => fn(this.callHistoryForCallId.toString())))
         .pipe(
            switchMap((c) => {
               if (_.isEmpty(c?.displayName)) {
                  return of(this.origAgentValue);
               }
               return of(c.displayName);
            })
         );
   }
}
